import { calc } from 'csx';
import { type Styles } from 'react-modal';
import { cssRaw } from 'typestyle';
import { type CSSProperties } from 'typestyle/lib/types';
import StyleConstants from '../../../core/styles.constants';
import 'react-calendar/dist/Calendar.css';

export const modalStyle = (isMobile?: boolean): Styles => ({
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    boxShadow: '1px 2px 15px rgba(0, 0, 0, 0.25)',
    borderRadius: 8,
    width: '90%',
    maxHeight: '90%',
    padding: 40,
    maxWidth: isMobile ? calc('100% - 30px') : undefined,
    backgroundColor: StyleConstants.WHITE_COLOR,
  },
});

export const modalBody: CSSProperties = {
  wordBreak: 'break-word',
  lineBreak: 'strict',
  textAlign: 'right',
  fontSize: StyleConstants.CARD_BODY_FONT_SIZE,
  fontWeight: StyleConstants.CARD_BODY_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
  width: '100%',
};

export const modalTitle: CSSProperties = {
  wordBreak: 'break-word',
  fontSize: StyleConstants.CARD_TITLE_FONT_SIZE,
  fontWeight: StyleConstants.CARD_TITLE_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
};

export const columnHeader: CSSProperties = {
  wordBreak: 'break-word',
  fontSize: StyleConstants.HEADER_FONT_SIZE,
  fontWeight: StyleConstants.HEADER_FONT_WEIGHT,
  fontFamily: StyleConstants.HEADER_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
  padding: 12,
};

export const dateText: CSSProperties = {
  wordBreak: 'break-word',
  fontSize: StyleConstants.PRIMARY_FONT_SIZE,
  fontWeight: StyleConstants.PRIMARY_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
  padding: 12,
};

export const modalList: CSSProperties = {
  marginTop: 24,
  marginBottom: 24,
};

export const button: CSSProperties = {
  marginTop: 12,
};

export const bodyText: CSSProperties = {
  marginBottom: 8,
  wordBreak: 'break-word',
  textAlign: 'center',
  fontSize: StyleConstants.CARD_TITLE_FONT_SIZE,
  fontWeight: StyleConstants.CARD_TITLE_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
};

export const preText: CSSProperties = {
  marginTop: 5,
  marginRight: 25,
  marginLeft: 12,
  fontSize: StyleConstants.CARD_TITLE_FONT_SIZE,
  fontWeight: StyleConstants.CARD_TITLE_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
};

export const deleteButton: CSSProperties = {
  cursor: 'pointer',
  wordBreak: 'break-word',
  marginTop: 12,
  fontSize: StyleConstants.CARD_BODY_FONT_SIZE,
  fontWeight: StyleConstants.CARD_BODY_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.PINK_COLOR,
};

export const deleteIcon: CSSProperties = {
  height: 24,
  maxWidth: 24,
};

export const rowItem = (isLastItem = false): CSSProperties => ({
  marginBottom: isLastItem ? 0 : 12,
  width: '100%',
});

export const bodyMargin = (isMobile: boolean): CSSProperties => ({
  marginLeft: isMobile ? 16 : 56,
  marginRight: isMobile ? 16 : 56,
  marginTop: isMobile ? 16 : 33,
});

export const switchBoxShadow = '0px 1px 5px rgba(0, 0, 0, 0.6)';
export const switchActiveBoxShadow = '0px 0px 1px 10px rgba(0, 0, 0, 0.2)';
export const switchHeight = 20;
export const switchWidth = 48;
export const switchDiameter = 30;

cssRaw(
  `
  .react-date-picker__calendar {
    background: #FFFFFF;
    border-radius: 8px;
    box-shadow: 1px 2px 15px rgba(0, 0, 0, 0.1);
    padding: 14px;
  }

  .react-date-picker__inputGroup__input {
    color: #575756;
  }

  .react-date-picker__inputGroup__divider {
    color: #575756;
  }

  .react-date-picker__wrapper{
    border: none;
  }

  .react-date-picker__calendar-button react-date-picker__button :hover{
    color: #26459C;
  }
  .react-calendar__tile--active:enabled:hover, .react-calendar__tile--active:enabled {
    background: none;
    border: solid #26459C;
    color: #FFF;
  }

  .react-calendar__navigation__arrow {
    width: 30px;
    color: grey;
    border: 0px;
  }

  button[class*="existing_entry_calendar_cell"] abbr::before {
    content: "";
    position: absolute;
    display: block;
    border-radius: 50%;
    background-color: #328BE0;
    width: 34px;
    height: 34px;
    left: 50%;
    top: 50%;
    transform: translate(-17px, -17px);
    z-index: -1
  }

  button[class*="existing_entry_calendar_cell"] {
    background-color: white;
    border: 0px;
  }

  button[class*="existing_entry_calendar_cell"] abbr {
    color: white;
  }


  button[class*="existing_entry_today_calendar_cell"] abbr {
    color: orange;
    text-decoration: underline;
  }

  button[class*="existing_entry_today_calendar_cell"] abbr::before {
    content: "";
    position: absolute;
    display: block;
    border-radius: 50%;
    background-color: #328BE0;
    width: 34px;
    height: 34px;
    left: 50%;
    top: 50%;
    transform: translate(-17px, -17px);
    z-index: -1
  }

  button[class*="react-calendar__navigation__label"] {
    background-color: #C0C0C050;
  }
  `,
);

export const calendar: CSSProperties = {
  fontWeight: StyleConstants.CARD_BODY_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  marginTop: 15,
  marginBottom: 15,
  width: '400px',
  height: '340px',
  border: '0px',
};

export const defaultCalendarCell: CSSProperties = {
  fontSize: StyleConstants.CARD_BODY_FONT_SIZE,
  fontWeight: StyleConstants.CARD_BODY_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
  border: StyleConstants.CALENDAR_TILE_BORDER_SIZE,
  background: StyleConstants.WHITE_COLOR,
};

export const disabledCalendarCell: CSSProperties = {
  fontSize: StyleConstants.CARD_BODY_FONT_SIZE,
  fontWeight: StyleConstants.CARD_BODY_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: `${StyleConstants.GREY_COLOR}50`,
  border: StyleConstants.CALENDAR_TILE_BORDER_SIZE,
  height: StyleConstants.CALENDAR_CELL_HEIGHT,
  background: `${StyleConstants.LIGHT_GREY_COLOR}50`,
};

export const horizontalDivider: CSSProperties = {
  opacity: 0.5,
  height: 1,
  backgroundColor: 'rgba(36, 55, 75, 0.2)',
  marginBottom: 10,
  marginTop: 5,
};

export const todayCalendarCell: CSSProperties = {
  fontSize: StyleConstants.CARD_BODY_FONT_SIZE,
  fontWeight: StyleConstants.CARD_BODY_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.ORANGE_COLOR,
  border: StyleConstants.CALENDAR_TILE_BORDER_SIZE,
  background: StyleConstants.WHITE_COLOR,
  textDecoration: 'underline',
};
